export default __webpack_public_path__ + "static/media/2-SOLUTION-FR.7e18f459.pdf";